import { useAuth } from '../../context/AuthContext';
import { ChevronDownIcon, Bars3Icon } from '@heroicons/react/24/outline';
import NotificationBell from '../NotificationBell';
import { deriveNameFromEmail } from '../../utils/nameFromEmail';

const headerStyle = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600&display=swap');
  .a-header { height:60px; min-height:60px; background:#ffffff; border-bottom:1px solid #eaecf4; display:flex; align-items:center; justify-content:space-between; padding:0 24px; font-family:'Sora',sans-serif; flex-shrink:0; z-index:10; }
  .a-header-left { display:flex; align-items:center; gap:8px; }
  .a-breadcrumb { font-size:.8rem; color:#b0b5cc; }
  .a-sep { color:#d8dce8; font-size:.8rem; }
  .a-page { font-size:.82rem; color:#1a1d2e; font-weight:600; }
  .a-right { display:flex; align-items:center; gap:8px; }
  .a-icon-btn { width:36px; height:36px; border-radius:10px; border:1px solid #eaecf4; background:#f8f9fc; display:flex; align-items:center; justify-content:center; cursor:pointer; transition:background .15s; position:relative; }
  .a-icon-btn:hover { background:#f0f2f8; }
  .a-icon-btn svg { width:17px; height:17px; stroke:#6b7194; stroke-width:1.7; }
  .a-divider { width:1px; height:24px; background:#eaecf4; margin:0 4px; }
  .a-user { display:flex; align-items:center; gap:10px; padding:5px 10px 5px 5px; border-radius:12px; cursor:pointer; transition:background .15s; border:1px solid transparent; }
  .a-user:hover { background:#f5f6fb; border-color:#eaecf4; }
  .a-avatar { width:32px; height:32px; border-radius:10px; background:linear-gradient(135deg,#3b6ef8,#8b5cf6); display:flex; align-items:center; justify-content:center; font-size:.75rem; font-weight:700; color:white; flex-shrink:0; }
  .a-name { font-size:.8rem; font-weight:600; color:#1a1d2e; }
  .a-role { font-size:.68rem; color:#9094a8; margin-top:2px; }
  .a-user svg { width:14px; height:14px; stroke:#b0b5cc; stroke-width:2; margin-left:2px; }
  .a-logout { padding:7px 14px; background:#fff1f1; color:#ef4444; border:1px solid #fecaca; border-radius:9px; font-size:.78rem; font-weight:600; font-family:'Sora',sans-serif; cursor:pointer; transition:background .15s; }
  .a-logout:hover { background:#fee2e2; }
  .a-hamburger { display:none; }
  @media (max-width:768px) {
    .a-header { padding:0 16px; }
    .a-hamburger { display:flex; }
    .a-breadcrumb, .a-sep { display:none; }
    .a-name, .a-role, .a-user svg { display:none; }
    .a-user { padding:4px; }
    .a-divider { display:none; }
    .a-logout { padding:6px 10px; font-size:.72rem; }
  }
`;

const getInitials = (name='') => name.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2) || 'A';

const Header = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const displayName = user?.name || deriveNameFromEmail(user?.email) || 'Admin';
  return (
    <>
      <style>{headerStyle}</style>
      <header className="a-header">
        <div className="a-header-left">
          <button className="a-icon-btn a-hamburger" onClick={onMenuClick} style={{border:'none',background:'transparent'}}>
            <Bars3Icon />
          </button>
          <span className="a-breadcrumb">School Portal</span>
          <span className="a-sep">/</span>
          <span className="a-page">Admin</span>
        </div>
        <div className="a-right">

          {/* ── Notification Bell ── */}
          <NotificationBell />

          <div className="a-divider" />
          <div className="a-user">
            <div className="a-avatar">{getInitials(displayName)}</div>
            <div>
              <div className="a-name">{displayName}</div>
              <div className="a-role">Administrator</div>
            </div>
            <ChevronDownIcon />
          </div>
          <div className="a-divider" />
          <button className="a-logout" onClick={logout}>Logout</button>
        </div>
      </header>
    </>
  );
};

export default Header;